import { APIResponse } from '@/types';
import {
    FindUserResponse,
    FindUserRequest,
    SyncUserStoreRequest,
    SyncUserStoreResponse,
    GetRoleResponse,
    GetAbilitiesResponse,
    CreateRoleRequest,
    CreateRoleResponse,
    UpdateRoleRequest,
    UpdateRoleResponse,
    DeleteRoleResponse,
    CreateAccountRequest,
    CreateAccountResponse,
    CreateClusterResponse,
    EditClusterRequest,
    EditClusterResponse,
    FetchClusterDetailRequest,
    FetchClusterDetailsResponse,
    FetchAccountResponse,
    EditAccountRequest,
    EditAccountResponse,
    SyncUserRoleRequest,
    SyncUserRoleResponse,
    DeleteAccountRequest,
    DeleteAccountResponse,
    DeleteClusterResponse,
    DeleteClusterRequest,
    GetRoleListResponse,
} from '@/types/pages/admin/apiRBAC';
import httpService from '@/api/httpService';
import { CreateClusterRequest, ClusterListRequest, ClusterListResponse } from '@/types/pages/admin/apiRBAC';
import { BaseAccount } from '@/types/pages/admin/account';

export function findUserAPI(data: FindUserRequest): APIResponse<FindUserResponse> {
    return httpService.post('/rbac/find-user', data);
}

export function findAllUserAPI(data: FindUserRequest, options?: { signal?: AbortSignal }): APIResponse<BaseAccount[]> {
    return httpService.post('/rbac/find-user', data, { signal: options?.signal });
}

export function syncUserStoreAPI(data: SyncUserStoreRequest): APIResponse<SyncUserStoreResponse> {
    return httpService.post('/rbac/sync-user-store', data);
}

export function syncUserRolesAPI(data: SyncUserRoleRequest): APIResponse<SyncUserRoleResponse> {
    return httpService.post('/rbac/sync-user-roles', data);
}

export function getRoleListAPI(cid: number): APIResponse<GetRoleListResponse> {
    return httpService.get(`/rbac/roles/${cid}`);
}

export function getAbilitiesAPI(options?: { signal?: AbortSignal }): APIResponse<GetAbilitiesResponse> {
    return httpService.get(`/rbac/abilities`, { signal: options?.signal });
}

export function getRoleAPI(cid: number, rid: number, options?: { signal?: AbortSignal }): APIResponse<GetRoleResponse> {
    return httpService.get(`/rbac/roles/${cid}/${rid}`, { signal: options?.signal });
}

export function createRoleAPI(cid: number, data: CreateRoleRequest): APIResponse<CreateRoleResponse> {
    return httpService.post(`/rbac/roles/${cid}`, data);
}

export function updateRoleAPI(cid: number, rid: number, data: UpdateRoleRequest): APIResponse<UpdateRoleResponse> {
    return httpService.put(`/rbac/roles/${cid}/${rid}`, data);
}

export function deleteRoleAPI(cid: number, rid: number): APIResponse<DeleteRoleResponse> {
    return httpService.delete(`/rbac/roles/${cid}/${rid}`);
}

export function fetchAccountInfoAPI(userId: number): APIResponse<FetchAccountResponse> {
    return httpService.get(`/user/${userId}`);
}

export function createAccountAPI(data: CreateAccountRequest): APIResponse<CreateAccountResponse> {
    return httpService.post(`/rbac/create-user-account`, data);
}

export function editAccountAPI(userId: number, data: EditAccountRequest): APIResponse<EditAccountResponse> {
    return httpService.put(`/user/${userId}`, data);
}

export function deleteAccountAPI(userId: number, data?: DeleteAccountRequest): APIResponse<DeleteAccountResponse> {
    return httpService.delete(`/user/${userId}`, { data });
}

export function fetchClusterListAPI(
    params: ClusterListRequest,
    options?: { signal?: AbortSignal },
): APIResponse<ClusterListResponse> {
    return httpService.get(`/cluster`, { params, signal: options?.signal });
}

export function createClusterAPI(data: CreateClusterRequest): APIResponse<CreateClusterResponse> {
    return httpService.post(`/cluster`, data);
}

export function editClusterAPI(clusterId: number, data: EditClusterRequest): APIResponse<EditClusterResponse> {
    return httpService.put(`/cluster/${clusterId}`, data);
}

export function deleteClusterAPI(clusterId: number, data: DeleteClusterRequest): APIResponse<DeleteClusterResponse> {
    return httpService.delete(`/cluster/${clusterId}`, { data });
}

export function fetchClusterDetailAPI(
    clusterId: number,
    params: FetchClusterDetailRequest,
): APIResponse<FetchClusterDetailsResponse> {
    return httpService.get(`/cluster/${clusterId}`, { params });
}
